// src/App.js - Updated with authentication and competition management
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SideMenu from './components/SideMenu';
import Administration from './components/Administration';
import AdminDashboard from './components/AdminDashboard';
import MarshallArea from './components/MarshallArea';
import MarshallAreaStandalone from './components/MarshallAreaStandalone';
import ChairAdjudicator from './components/ChairAdjudicator';
import ChairAdjudicatorStandalone from './components/ChairAdjudicatorStandalone';
import Scrutineer from './components/Scrutineer';
import Compere from './components/Compere';
import DisplayScreen from './components/DisplayScreen';
import CouplesList from './components/CouplesList';
import Callbacks from './components/Callbacks';
import RunningList from './components/RunningList';
import Login from './auth/Login';
import CompetitionSelection from './competition/CompetitionSelection';
import AuditTrail from './components/AuditTrail';
import Payments from './components/Payments';
import { AuthProvider } from './auth/AuthContext';
import { CompetitionProvider } from './competition/CompetitionContext';
import ProtectedRoute from './auth/ProtectedRoute';
import RoleBasedRoute from './auth/RoleBasedRoute';
import CompetitionGuard from './competition/CompetitionGuard';
import './App.css';

// Layout component for pages with side menu
function MainLayout({ children }) {
  return (
    <div className="app-with-sidemenu">
      <SideMenu />
      <div className="main-content">
        {children}
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <CompetitionProvider>
        <Router>
          <div className="app">
            <Routes>
              {/* Login route */}
              <Route path="/login" element={<Login />} />

              {/* Competition selection route */}
              <Route path="/select-competition" element={
                <ProtectedRoute>
                  <CompetitionSelection />
                </ProtectedRoute>
              } />

              {/* Protected routes with side menu that require competition selection and role-based access */}
              <Route path="/administration" element={
                <RoleBasedRoute requiredPermission="administration">
                  <CompetitionGuard>
                    <MainLayout><Administration /></MainLayout>
                  </CompetitionGuard>
                </RoleBasedRoute>
              } />
              <Route path="/screen-management" element={
                <RoleBasedRoute requiredPermission="screen-management">
                  <CompetitionGuard>
                    <MainLayout><AdminDashboard /></MainLayout>
                  </CompetitionGuard>
                </RoleBasedRoute>
              } />
              <Route path="/scrutineer" element={
                <RoleBasedRoute requiredPermission="scrutineer">
                  <CompetitionGuard>
                    <MainLayout><Scrutineer /></MainLayout>
                  </CompetitionGuard>
                </RoleBasedRoute>
              } />
              <Route path="/chair-adjudicator" element={
                <RoleBasedRoute requiredPermission="chair-adjudicator">
                  <CompetitionGuard>
                    <MainLayout><ChairAdjudicator /></MainLayout>
                  </CompetitionGuard>
                </RoleBasedRoute>
              } />
              <Route path="/compere" element={
                <RoleBasedRoute requiredPermission="compere">
                  <CompetitionGuard>
                    <MainLayout><Compere /></MainLayout>
                  </CompetitionGuard>
                </RoleBasedRoute>
              } />
              <Route path="/audit-trail" element={
                <RoleBasedRoute requiredPermission="audit-trail">
                  <CompetitionGuard>
                    <MainLayout><AuditTrail /></MainLayout>
                  </CompetitionGuard>
                </RoleBasedRoute>
              } />

              {/* Legacy routes - redirect to role-based routes */}
              <Route path="/admin" element={
                <RoleBasedRoute requiredPermission="screen-management">
                  <CompetitionGuard>
                    <Navigate to="/screen-management" replace />
                  </CompetitionGuard>
                </RoleBasedRoute>
              } />
              <Route path="/marshall-area" element={
                <RoleBasedRoute requiredPermission="marshall-area">
                  <CompetitionGuard>
                    <MainLayout><MarshallArea /></MainLayout>
                  </CompetitionGuard>
                </RoleBasedRoute>
              } />
              <Route path="/couples" element={
                <RoleBasedRoute requiredPermission="administration">
                  <CompetitionGuard>
                    <MainLayout><CouplesList /></MainLayout>
                  </CompetitionGuard>
                </RoleBasedRoute>
              } />
              <Route path="/payments" element={
                <RoleBasedRoute requiredPermission="administration">
                  <CompetitionGuard>
                    <MainLayout><Payments /></MainLayout>
                  </CompetitionGuard>
                </RoleBasedRoute>
              } />

              
              {/* Public display routes (no side menu) */}
              <Route path="/display" element={<DisplayScreen />} />
              <Route path="/callbacks" element={<Callbacks />} />
              <Route path="/running-list" element={<RunningList />} />
              <Route path="/running-list/:competitionId/:clothNumber" element={<RunningList />} />
              <Route path="/:competitionId/:clothNumber" element={<RunningList />} />
              <Route path="/:competitionId" element={<RunningList />} />
              <Route path="/marshall-area/:competitionId" element={<MarshallAreaStandalone />} />
              <Route path="/chair-adjudicator/:competitionId" element={<ChairAdjudicatorStandalone />} />

              {/* Default route */}
              <Route path="/" element={<Navigate to="/select-competition" replace />} />
            </Routes>
          </div>
        </Router>
      </CompetitionProvider>
    </AuthProvider>
  );
}

export default App;